"use client";

import { useEffect, useState } from "react";
import {
  motion,
  useMotionValue,
  useTransform,
  animate,
} from "framer-motion";

const IMGS = [
  {
    src: "assets/ongoing/giriraj-sapphire-kharghar.jpg",
    title: "Giriraj Sapphire",
  },
  {
    src: "assets/ongoing/laxmi-pristine.jpg",
    title: "Laxmi Prestige",
  },
  {
    src: "assets/ongoing/mass-insignia.jpg",
    title: "Mass Insignia",
  },
  {
    src: "assets/ongoing/Omkara-Pride.jpg",
    title: "Omkara Pride",
  },
  {
    src: "assets/ongoing/Rachna-4D-Life.jpg",
    title: "Rachna 4D Life",
  },
  {
    src: "assets/ongoing/rudra-big-space.jpg",
    title: "Rudra Big Space",
  },
    {
    src: "assets/ongoing/siddhivinayak enclave.jpg",
    title: "Siddhivinayak Orcid",
  },
    {
    src: "assets/ongoing/sidhivinayak sharvam.jpg",
    title: "Siddhivinayak Sarvam",
  },
];

const RollingGallery = ({
  autoplay = false,
  pauseOnHover = false,
  images = [],
}) => {
  images = images.length > 0 ? images : IMGS;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const faceCount = images.length;
  const faceWidth = isMobile ? 160 : 240;
  const faceHeight = isMobile ? 200 : 300;
  const cylinderCircumference = faceWidth * faceCount * 1.1;
  const radius = cylinderCircumference / (2 * Math.PI);

  const rotation = useMotionValue(0);
  const transform = useTransform(
    rotation,
    (val) => `rotate3d(0, 1, 0, ${val}deg)`
  );

  useEffect(() => {
    if (!autoplay) return;

    let currentRotation = rotation.get();

    const loop = () => {
      animate(rotation, currentRotation - 360, {
        duration: 40,
        ease: "linear",
        onComplete: () => {
          currentRotation -= 360;
          loop();
        },
      });
    };

    loop();

    return () => {
      rotation.stop?.();
    };
  }, [autoplay, rotation]);

  const handleDrag = (_, info) => {
    rotation.set(rotation.get() + info.offset.x * 0.3);
  };

  const handleMouseEnter = () => {
    if (autoplay && pauseOnHover) {
      rotation.stop?.();
    }
  };

  const handleMouseLeave = () => {
    if (autoplay && pauseOnHover) {
      let currentRotation = rotation.get();

      const loop = () => {
        animate(rotation, currentRotation - 360, {
          duration: 40,
          ease: "linear",
          onComplete: () => {
            currentRotation -= 360;
            loop();
          },
        });
      };

      loop();
    }
  };

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-[#741112] mb-3">
            Ongoing Projects
          </h2>
          <p className="text-base text-gray-700 max-w-3xl mx-auto">
            We’re proud to partner with visionary developers on projects that are currently transforming skylines, communities, and lives.
          </p>
        </div>

        <div className="relative h-[350px] md:h-[500px] w-full overflow-hidden">
          <div className="flex items-center justify-center h-full [perspective:1200px]">
            <motion.div
              drag="x"
              dragElastic={0.1}
              onDrag={handleDrag}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{
                transform,
                width: cylinderCircumference,
                transformStyle: "preserve-3d",
              }}
              className="relative flex items-center justify-center h-full"
            >
              {images.map(({ src, title }, i) => (
                <motion.div
                  key={i}
                  className="absolute flex flex-col items-center"
                  style={{
                    width: `${faceWidth}px`,
                    height: `${faceHeight}px`,
                    transform: `rotateY(${(360 / faceCount) * i}deg) translateZ(${radius}px)`,
                  }}
                >
                  <div className="w-full h-full rounded-lg overflow-hidden shadow-md border border-gray-100">
                    <img
                      src={src}
                      alt={title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="mt-2 text-center text-[#741112] text-sm font-medium">
                    {title}
                  </span>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RollingGallery;
